import { Component, OnInit, Input } from '@angular/core';
import { ApiService } from 'src/app/service/api.service'

@Component({
  selector: 'app-qtn-header-footer-print',
  templateUrl: './qtn-header-footer-print.component.html',
  styleUrls: ['./qtn-header-footer-print.component.css']
})
export class QtnHeaderFooterPrintComponent implements OnInit {
  @Input()saleQtnData;
  @Input()print_style;
  @Input()savedTemplate;
  @Input()is_prew_description;
  @Input()cmpny;
  @Input()previewLoader;
  @Input()logoImgUrl;
  @Input()footImgUrl;
  @Input()tempImgUrl;
  @Input()sales_print_name;
  @Input()sales_settings;
  base_url_s3_prod = '';
  constructor(private apiService: ApiService) { }

  ngOnInit() {
    this.base_url_s3_prod = this.apiService.S3_SERVER + '/uploads/products/'
  }

}
